// PlatformGuard — the frontend half of the isolation boundary (defense in
// depth alongside the backend's requirePlatformAdmin).
//
// Mirrors AuthGuard exactly in shape (same loading/redirect logic) but reads
// from PlatformAuthContext, never AuthContext. A tenant-agent session (or no
// session at all) is treated IDENTICALLY here — both simply fail
// isAuthenticated and are redirected to /super_admin/login, with zero content
// flash (loading gate) and zero information about which case it was.

import { type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { usePlatformAuth } from '../context/PlatformAuthContext';
import { WorkspaceLoading } from './WorkspaceLoading';

export function PlatformGuard({ children }: { children: ReactNode }) {
  const { isAuthenticated, loading } = usePlatformAuth();
  const location = useLocation();

  // Wait for the initial /me check before deciding where to navigate — avoids
  // a flash of the login redirect (or of protected content) on hard reload.
  if (loading) {
    return <WorkspaceLoading />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/super_admin/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
